import './index.scss';

const blockGridCardsIcons = () => {
	
};

export default blockGridCardsIcons;
